import Vue from 'vue';
import store from './../../store';
import billProductTransformer from './../../transformers/creditNoteProduct';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const billProducts = billProductTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllBillProducts', billProducts);
  resolve(billProducts);
};

const failed = (error, reject) => reject(error);

export default (id, options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`/bills/${id}/products/search-order-product`, options))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billProduct/search.js